import { useEffect, useState } from 'react';
import './home.css';
import { delay, motion } from "framer-motion";



export function HomePage() {

    const titleTop = "KANHA";
    const titleBottom = "AMANTA";
    const subtitle = "Full Stack Developer";
    const imageSrc = "Profile_1.jpeg";
    const alt = "Indhu Botcha";
    const name = "Pravanjan Amanta".split("");

    const letters = (word) => [...word];

    const [animate, setAnimate] = useState(false);

useEffect(() => {
  setAnimate(true); // triggers animation on mount
}, []);


    // Parent container animation for letters
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                delayChildren: 1, // wait 1 second before animating letters
                staggerChildren: 0.08, // delay between each letter
            },
        },
    };

    // Each letter animation
    const letterVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.4, ease: "easeOut" },
        },
    };


    return (
        <div className="container-fluid bg bg-black d-flex justify-content-center align-items-center home-page" style={{ height: "100vh", width: "100%" }}>

            {/* <div className='home-sub-div'>
                <h3 data-aos="zoom-in" data-aos-delay="2000">What's up! I'm</h3>
                <h1 className='name-head'>
                    <span data-aos="fade-up" data-aos-delay="2000">P</span>
                    <span data-aos="fade-up" data-aos-delay="2050">r</span>
                    <span data-aos="fade-up" data-aos-delay="2100">a</span>
                    <span data-aos="fade-up" data-aos-delay="2150">v</span>
                    <span data-aos="fade-up" data-aos-delay="2200">a</span>
                    <span data-aos="fade-up" data-aos-delay="2250">n</span>
                    <span data-aos="fade-up" data-aos-delay="2300">j</span>
                    <span data-aos="fade-up" data-aos-delay="2350">a</span>
                    <span data-aos="fade-up" data-aos-delay="2400">n</span>
                    <span id="spaceName" data-aos="fade-up" data-aos-delay="2450"> </span>
                    <span data-aos="fade-up" data-aos-delay="2500">A</span>
                    <span data-aos="fade-up" data-aos-delay="2550">m</span>
                    <span data-aos="fade-up" data-aos-delay="2600">a</span>
                    <span data-aos="fade-up" data-aos-delay="2650">n</span>
                    <span data-aos="fade-up" data-aos-delay="2700">t</span>
                    <span data-aos="fade-up" data-aos-delay="2750">a</span>
                </h1>
                <h2 data-aos="flip-down" data-aos-delay="2200">I like making websites</h2>
                <p data-aos="flip-up" data-aos-delay="2200">Hey there! Welcome to my front-end portfolio site! Here you can check out some of the cool stuff I've
                    designed and developed. Come on in and have a look around!</p>
                <div className="unbox" data-aos="flip-down" data-aos-delay="2200">
                    <a href="https://github.com/Prabhanjan-17p" target="_blank">
                        <img src="github.svg" alt="" />
                    </a>
                    <a href="mailto:pravanjanamanta@gmail.com" target="_blank">
                        <img src="facebook.svg" alt="" />
                    </a>
                    <img src="tweter.svg" alt="" />
                    <a href="https://www.linkedin.com/in/pravanjan-17p/" target="_blank">
                        <img src="linkdin.svg" alt="" />
                    </a>
                </div>
            </div> */}


            <div key={window.location.pathname} className="home-sub-div">
                {/* === h3 (slide up) === */}
                <motion.h3
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.5, ease: "easeOut" }}
                >
                    What's up! I'm
                </motion.h3>

                {/* === Animated Name (letter by letter) === */}
                <motion.h1
                    className="name-head"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    {name.map((char, index) => (
                        <motion.span key={index} variants={letterVariants}>
                            {char === " " ? "\u00A0" : char}
                        </motion.span>
                    ))}
                </motion.h1>

                {/* === h2 (slide up) === */}
                <motion.h2
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 2, ease: "easeOut" }}
                >
                    I like making websites
                </motion.h2>

                {/* === paragraph (fade-up) === */}
                <motion.p
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 2.5, ease: "easeOut" }}
                >
                    Hey there! Welcome to my front-end portfolio site! Here you can check out
                    some of the cool stuff I've designed and developed. Come on in and have
                    a look around!
                </motion.p>

                {/* === social icons (fade-up) === */}
                <motion.div
                    className="unbox"
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 3, ease: "easeOut" }}
                >
                    <a href="https://github.com/Prabhanjan-17p" target="_blank" rel="noreferrer">
                        <img src="github.svg" alt="GitHub" />
                    </a>
                    <a href="mailto:pravanjanamanta@gmail.com" target="_blank" rel="noreferrer">
                        <img src="facebook.svg" alt="Email" />
                    </a>
                    <img src="tweter.svg" alt="Twitter" />
                    <a href="https://www.linkedin.com/in/pravanjan-17p/" target="_blank" rel="noreferrer">
                        <img src="linkdin.svg" alt="LinkedIn" />
                    </a>
                </motion.div>
            </div>

            <div className='mob-home'>

                <section className="w-full flex justify-center items-center py-8"
                    style={{
                        marginTop: "-100px",
                    }}
                >
                    <div className="text-center max-w-full px-4">
                        <p className="text-base sm:text-sm text-gray-600 dark:text-gray-400 font-inter my-4" style={{ color: "whitesmoke" }}>{subtitle}</p>

                        <h1
                            className="leading-none relative tracking-wide mx-auto"
                            style={{
                                color: "#3b82f6",
                                // large default size, responsive adjustments below using inline style for exactness
                                fontSize: "5.5rem",
                                fontWeight: "500",
                                fontFamily: "Anton, sans-serif",
                                letterSpacing: "10px"
                            }}
                        >
                            {/* Top row (INDHU) */}
                            <div className="flex justify-center text-[7rem] md:text-[7.5rem] lg:text-[14rem]"
                                style={{ transform: "scaleY(1.3)" }}
                            >
                                {letters(titleTop).map((ch, i) => (
                                    <span
                                        key={i}
                                        className="inline-block"
                                        style={{ opacity: 1, transform: "none" }}
                                    >
                                        {ch}
                                    </span>
                                ))}
                            </div>



                            {/* Bottom row (BOTCHA) */}
                            <div className="flex justify-center text-[7rem] md:text-[6.5rem] lg:text-[14rem]"
                                style={{ transform: "scaleY(1.3)" }}
                            >
                                {letters(titleBottom).map((ch, i) => (
                                    <span
                                        key={i}
                                        className="inline-block"
                                        style={{ opacity: 1, transform: "none" }}
                                    >
                                        {ch}
                                    </span>
                                ))}
                            </div>


                            {/* centered circular image overlay */}
                            <div
                                className="absolute inset-0 flex items-center justify-center pointer-events-none"
                                style={{
                                    perspective: 800,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: "-155px",
                                    marginBottom: "-50px"
                                }}
                            >
                                <div
                                    className="rounded-full overflow-hidden"
                                    style={{
                                        width: 95,
                                        height: 110,
                                        transformStyle: "preserve-3d",
                                        opacity: 1,
                                        transform: "translateX(4.005px) translateY(-1.395px) rotateX(-1.395deg) rotateY(4.005deg)",
                                    }}
                                >
                                    <img
                                        src={imageSrc}
                                        alt={alt}
                                        width={928}
                                        height={1120}
                                        decoding="async"
                                        className="w-full h-full object-cover"
                                        style={{
                                            color: "transparent",
                                            height: "100%",
                                            width: "100%",
                                            objectFit: "cover",
                                            borderRadius: "30%",

                                        }}
                                    />
                                </div>
                            </div>
                        </h1>
                    </div>


                </section>
                <div
                    style={{
                        height: "70px",
                        width: "100%",
                        marginTop: "90px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <div className="unbox" data-aos="flip-down" data-aos-delay="2200">
                        <a href="https://github.com/Prabhanjan-17p" target="_blank">
                            <img src="github.svg" alt="" />
                        </a>
                        <a href="mailto:pravanjanamanta@gmail.com" target="_blank">
                            <img src="facebook.svg" alt="" />
                        </a>
                        <img src="tweter.svg" alt="" />
                        <a href="https://www.linkedin.com/in/pravanjan-17p/" target="_blank">
                            <img src="linkdin.svg" alt="" />
                        </a>
                    </div>
                </div>

            </div>
        </div>
    )
}